import React, { createContext, useContext, useState, useEffect } from 'react';

const TabsContext = createContext();

export const useTabs = () => {
  const context = useContext(TabsContext);
  if (!context) {
    // Return default values if context is not available (defensive programming)
    return {
      areTabsCollapsed: false,
      collapseTabs: () => {},
      expandTabs: () => {},
      toggleTabs: () => {},
    };
  }
  return context;
};

export const TabsProvider = ({ children }) => {
  const [areTabsCollapsed, setAreTabsCollapsed] = useState(() => {
    // Load from localStorage
    if (typeof window !== 'undefined') {
      try {
        const saved = localStorage.getItem('tabsCollapsed');
        if (saved !== null) {
          return saved === 'true';
        }
      } catch (e) {
        console.warn('Failed to parse tabsCollapsed from localStorage:', e);
      }
    }
    return false; // Default to expanded
  });

  // Save to localStorage whenever it changes
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('tabsCollapsed', areTabsCollapsed.toString());
    }
  }, [areTabsCollapsed]);

  const collapseTabs = () => {
    setAreTabsCollapsed(true);
  };

  const expandTabs = () => {
    setAreTabsCollapsed(false);
  };

  const toggleTabs = () => {
    setAreTabsCollapsed(prev => !prev);
  };

  return (
    <TabsContext.Provider value={{
      areTabsCollapsed,
      collapseTabs,
      expandTabs,
      toggleTabs,
    }}>
      {children}
    </TabsContext.Provider>
  );
};

